import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { APP_CONFIG } from '../../../config/app.config';
import { Icon, IconSize } from '@shared/icons';

interface OnboardingEntityEmptyRowProps {
  title: string;
  description?: string;
  actionLabel: string;
  onAction: () => void;
  /** Prefer contained for primary create CTAs. */
  actionVariant?: 'contained' | 'text';
}

const OnboardingEntityEmptyRow: React.FC<OnboardingEntityEmptyRowProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  actionVariant = 'contained',
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <Box
      sx={{
        border: 1,
        borderColor: colors.border,
        borderRadius: '8px',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2">{title}</Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
      <Button
        variant={actionVariant}
        onClick={onAction}
        startIcon={<Icon icon="Plus01" size={IconSize.MEDIUM} />}
      >
        {actionLabel}
      </Button>
    </Box>
  );
};

export default OnboardingEntityEmptyRow;
